export type CommunicationCategoryStatus = number | string;

export interface CommunicationCategoryApiResponse {
  id: number;
  company_id: number;
  name: string;
  description: string;
  code: string | null;
  is_system: boolean;
  status: CommunicationCategoryStatus;
}

export interface ListCommunicationCategoriesApiResponse {
  items: CommunicationCategoryApiResponse[];
}

export interface CommunicationCategory {
  id: number;
  companyId: number;
  name: string;
  description: string;
  code: string | null;
  isSystem: boolean;
  status: CommunicationCategoryStatus;
}

export interface CommunicationCategoryGridRow extends CommunicationCategory {
  typeLabel: string;
  rowActions: string[];
}

export interface CreateCommunicationCategoryRequest {
  name: string;
  description?: string;
  code?: string | null;
}

export interface UpdateCommunicationCategoryRequest {
  name: string;
  description?: string;
  code?: string;
}

export function isCommunicationCategoryActive(
  status: CommunicationCategoryStatus,
): boolean {
  if (typeof status === 'number') {
    return status === 1;
  }
  return String(status).toLowerCase() === 'active';
}

export function mapCommunicationCategoryFromApi(
  api: CommunicationCategoryApiResponse,
): CommunicationCategory {
  return {
    id: api.id,
    companyId: api.company_id,
    name: api.name,
    description: api.description ?? '',
    code: api.code,
    isSystem: api.is_system,
    status: api.status,
  };
}
